import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import QRCode from "react-qr-code";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";
import { mediaData } from "../data/mediaData";
// import config from "../data/config";
import { callGA } from "../data/common";
import { AnimatePresence } from "framer-motion";
import flagsmith from "flagsmith";
import { v4 as uuidv4 } from "uuid";

/* data import */
// import categoryList from "../data/JSON/category_list.json";

/* comp imports */
import TopThumbs from "../components/TopThumbs";
import SwiperWrapper from "../components/SwiperWrapper";
import SplashStartWrapper from "../components/SplashStartWrapper";
import SplashEndWrapper from "../components/SplashEndWrapper";
import SideStoriesWrapper from "../components/SideStoriesWrapper";
import EndSwitchButton from "../components/EndSwitchButton";
import QRWrapper from "../components/QRWrapper";
import FeedbackWrapper from "../components/FeedbackWrapper";
import AllStoriesWrapper from "../components/AllStoriesWrapper";

const isCollectFeedback = process.env.REACT_APP_IS_COLLECT_FEEDBACK === "true";

const FLAGSMITH_ID =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? process.env.REACT_APP_FLAGSMITH_ID_DEV
    : process.env.REACT_APP_FLAGSMITH_ID_PROD;

const Home = () => {
  const [searchParams] = useSearchParams();
  const url_story_id = searchParams.get("story_id");
  const modelId = searchParams.get("modelId");
  const pplId = searchParams.get("pplId");
  const navigateUrl = `https://ev.tatamotors.com/digital-showroom.html?modelId=${modelId}${
    pplId ? `&pplId=${pplId}` : ""
  }&story_id=${url_story_id}&utm_source=Webapp&utm_medium=Organic&utm_campaign=EOD&utm_content=Explore_your_car_in_3D`;
  const qrUrl = `https://ev.tatamotors.com/digital-showroom/eod.html?modelId=${modelId}${
    pplId ? `&pplId=${pplId}` : ""
  }&story_id=${url_story_id}&utm_source=Webapp&utm_medium=Organic&utm_campaign=Curvv_EV_Experience&utm_content=QR`;

  /**  use states */
  const swiperRef = useRef();
  const [categoryList, setCategoryList] = useState(null);
  const [categoryListData, setCategoryListData] = useState([]);
  const [splashListData, setSplashListData] = useState([]);
  const [currStoryId, setCurrStoryId] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalChapters, setTotalChapters] = useState(0);
  const [chapterHashTags, setChapterHashTags] = useState([]);
  const [storyHead, setStoryHead] = useState("");
  const [fromFirstSlide, setFromFirstSlide] = useState(false);
  const [fromEndScreen, setFromEndScreen] = useState(false);
  const [showStartScreen, setShowStartScreen] = useState(true);
  const [showEndScreen, setShowEndScreen] = useState(false);
  const [showFeedbackScreen, setShowFeedbackScreen] = useState(false);
  const [showAllStoriesScreen, setShowAllStoriesScreen] = useState(false);

  const [totalNumStories, setTotalNumStories] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);

  const [modelName, setModelName] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [isDisplayQRBlock, setIsDisplayQRBlock] = useState(false);
  const [idea, setIdea] = useState(0);
  const [isIdea, setIsIdea] = useState(false);

  /* use states end */
  useEffect(() => {
    // Retrieve or create UUID
    let storedUUID = localStorage.getItem("user_uuid");
    if (!storedUUID) {
      storedUUID = uuidv4();
      localStorage.setItem("user_uuid", storedUUID);
    }

    // Initialize Flagsmith
    flagsmith.init({
      environmentID: FLAGSMITH_ID,
      enableAnalytics: true,
      realtime: true,
      identity: storedUUID,
      onChange: () => {
        let idea;
        if (flagsmith.hasFeature("implement_idea_number")) {
          idea = flagsmith.getValue("implement_idea_number", {
            fallback: 0,
          });
        } else {
          idea = 0;
        }
        console.log(">>>>>>>>>>>idea ", idea);
        setIdea(() => idea);
        setIsIdea(() => true);
      },
    });
  }, []);

  useEffect(() => {
    if (url_story_id) {
      setCurrStoryId(Number(url_story_id));
    }
  }, [url_story_id]);

  useEffect(() => {
    if (modelId) {
      let fetchUrl = `/datas/${modelId}.json`;
      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => setCategoryList(data.response))
        .catch((error) =>
          console.error(
            "There has been a problem with your fetch operation:",
            error
          )
        );
    }
  }, [modelId]);

  // const getNewCategoriesListData = (storyId, categories) => {
  //   if (storyId) {
  //     const filteredCategories = categories.filter(category => category.category_id === parseInt(storyId));
  //     const remainingCategories = categories.filter(category => category.category_id !== parseInt(storyId));

  //     return [...filteredCategories, ...remainingCategories];
  //   }

  //   return categories
  // }

  useEffect(() => {
    if (categoryList) {
      // const categories = getNewCategoriesListData(currStoryId, categoryList.categories);
      setCategoryListData(categoryList.categories);
      setSplashListData(categoryList.splash_screen);
      setTotalNumStories(categoryList.categories.length);
      setModelName(categoryList.model_name);
      setFuelType(categoryList.fuel_type);
    }
  }, [categoryList]);

  const callGaHandler = (
    event_category,
    event_label,
    story_id = "",
    chapter_id = "",
    story_category_name = ""
  ) => {
    const new_story_id = currStoryId;
    const new_chapter_id = Number(currentIndex + 1);
    const utm_source = searchParams.get("utm_source");
    const utm_medium = searchParams.get("utm_medium");
    const utm_campaign = searchParams.get("utm_campaign");
    const utm_content = searchParams.get("utm_content");
    const model_name = modelName;
    const fuel_type = fuelType;
    const currentStory = categoryListData[Number(new_story_id) - 1] || {};

    callGA(
      event_category,
      event_label,
      model_name,
      fuel_type,
      utm_source ? utm_source : "NA",
      utm_medium ? utm_medium : "NA",
      utm_campaign ? utm_campaign : "NA",
      utm_content ? utm_content : "NA",
      Number(story_id) || new_story_id,
      Number(chapter_id) || new_chapter_id,
      story_category_name || currentStory?.category_name || "NA",
      "Set_" + idea
    );
  };

  const storyChangeHandler = (id, fromFirst, fromEndScreen, currIndex) => {
    setShowStartScreen(false);
    setShowEndScreen(false);
    setShowFeedbackScreen(false);
    if (id !== totalNumStories) {
      setCurrStoryId(id);

      if (idea === 1 && id === 5) {
        onShowFeedback(); //for idea set 1, show feedback form after 4 stories
      }
      if (fromFirst) {
        setCurrentIndex(totalChapters - 1);
        setFromFirstSlide(true);
      } else if (fromEndScreen) {
        setCurrentIndex(currIndex);
        setFromEndScreen(true);
      } else {
        setCurrentIndex(0);
        setFromFirstSlide(false);
        callGaHandler(
          "Stories",
          categoryListData[id - 1]?.category_name,
          id,
          1,
          categoryListData[id - 1]?.category_name
        );
      }

      const url = new URL(window.location.href);
      url.searchParams.set("story_id", id);
      window.history.pushState(null, "", url.toString());
    } else {
      // setShowEndScreen(true);
      if (idea === 0) {
        onShowFeedback(); //show feedback on end for control set
      } else {
        setShowEndScreen(true); // on end only show end screen
      }
      // callGaHandler("Enter3D", "Ready_screen");
    }
  };

  useEffect(() => {
    if (isIdea) {
      callGaHandler("Traffic", "Landing_screen_set");
    }
    // eslint-disable-next-line
  }, [isIdea]);

  useEffect(() => {
    if (modelName && fuelType) {
      callGaHandler("Traffic", "Landing_screen");
    }
    // eslint-disable-next-line
  }, [modelName, fuelType]);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1200;
      const isLandscape = window.innerWidth > window.innerHeight;
      setIsMobile(isMobile);
      setIsLandscape(isLandscape);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNavigateTo3d = () => {
    pauseSlideOnTap(false, "pause");
    // 3d explore
    callGaHandler("Enter3D", "Explore_your_car_in_3D");
    window.open(navigateUrl, "_blank");
  };

  const exploreIn3dHandler = () => {
    handleNavigateTo3d();
  };

  const onTouchEndDesktop = () => {
    setShowStartScreen(false);
    storyChangeHandler(currStoryId, false);
    callGaHandler("Traffic", "Story_page");
    callGaHandler("Swipe", "Swiped_successfully");
  };

  const onOpenQRWrapperHandler = () => {
    pauseSlideOnTap(false, "pause");
    setIsDisplayQRBlock(true);
    callGaHandler("QR", "QR_open");
  };

  const onCloseQRWrapperHandler = () => {
    pauseSlideOnTap(false, "play");
    setIsDisplayQRBlock(false);
    callGaHandler("QR", "QR_close");
  };

  const isDisplayOverlayScreen = () => {
    return (
      showStartScreen ||
      showEndScreen ||
      showFeedbackScreen ||
      showAllStoriesScreen
    );
  };

  const isDisplaySwiper = (isMobileView = false) => {
    const isDisplay =
      categoryListData &&
      categoryListData.length > 0 &&
      !showStartScreen &&
      !showEndScreen &&
      !showFeedbackScreen;

    if (isMobileView) {
      return isDisplay && isMobile;
    }

    return isDisplay;
  };

  const onShowFeedback = () => {
    if (isCollectFeedback) {
      const isFeedbackSubmitted =
        localStorage.getItem("feedback_submitted") === "true";
      const isCloseFeedback = localStorage.getItem("close_feedback") === "true";
      if (idea === 2) {
        setShowEndScreen(true);
      } else {
        if (!isFeedbackSubmitted && !isCloseFeedback) {
          setShowFeedbackScreen(true);
          callGaHandler("Feedback_screen", "open");
        } else {
          setShowEndScreen(true);
        }
      }
    } else {
      setShowEndScreen(true);
    }
  };

  const onShowAllStories = () => {
    setShowAllStoriesScreen(true);
  };

  const pauseSlideOnTap = (...rest) => {
    swiperRef.current?.pauseSlideOnTap(...rest);
  };

  return (
    <section>
      <ToastContainer
        position={isMobile ? "bottom-center" : "top-right"}
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="light"
        transition={Bounce}
      />
      <div className="container-fluid">
        {/* splash screen for desktop  */}
        {showStartScreen && !isMobile && (
          <div className="row one3d-splash-screen-wrapper">
            <div className="col-12 col-xl-8">
              <div className="one3d-splash-screen-left">
                {/* <div
                  className="one3d-splash-screen-logo"
                  onClick={() => {
                    window.location.href = "https://ev.tatamotors.com";
                  }}
                >
                  <img src={`${mediaData["brandLogoGrey"]}`} alt="" />
                </div> */}
                <div className="one3d-splash-screen-left-inner-bg">
                  <div className="one3d-splash-screen-left-row">
                    <div className="one3d-splash-screen-left-title">
                      {/* <p>A brand new way to explore</p> */}
                      <h3>
                        <span>Curvv.ev</span>{" "}
                        <i>
                          <b>suv</b> coupé
                        </i>
                      </h3>
                    </div>
                  </div>
                  <div className="one3d-splash-screen-left-row">
                    <div className="one3d-splash-screen-left-car">
                      <span className="image">
                        <img src={`${mediaData["brandCar"]}`} alt="" />
                      </span>
                      <div className="one3d-splash-screen-left-car-caption">
                        <p>buckle up for an experience</p>
                        <h4>
                          shaped for - <span>you</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-xl-4">
              <div className="one3d-splash-screen-right">
                <div className="one3d-splash-screen-right-inner-bg">
                  <div className="one3d-splash-screen-right-row">
                    <div className="one3d-qr-code-info">
                      <h4>We are better on phone!</h4>
                      <p>
                        Scan this QR code on your phone for a better experience
                      </p>
                    </div>
                    <div className="one3d-qr-code-img">
                      <span>
                        <b>
                          {/* <img src={`${mediaData["qrSplashIcon"]}`} alt="" /> */}
                          <QRCode
                            size={256}
                            bgColor="#E0E6F2"
                            fgColor="#313C5A"
                            style={{
                              height: "auto",
                              maxWidth: "100%",
                              width: "100%",
                            }}
                            value={qrUrl}
                            viewBox={`0 0 256 256`}
                          />
                        </b>
                      </span>
                    </div>
                  </div>

                  <div className="one3d-splash-screen-right-row">Or</div>
                  <div className="one3d-splash-screen-right-row one3d-continue-button-inner">
                    <button
                      className="one3d-continue-button"
                      onClick={onTouchEndDesktop}
                    >
                      <span>Continue on desktop</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* splash screen for desktop  */}

        <div className="row">
          <div
            className="col-12 col-xl-9 px-0 py-xl-5"
            style={{
              position: "relative",
              backdropFilter: isDisplayQRBlock ? "invert(0.2)" : "invert(0)",
            }}
          >
            <div
              className={`main-stories-wrapper ${
                isDisplayOverlayScreen() && !isMobile
                  ? "main-stories-wrapper-desktop"
                  : ""
              }`}
            >
              {!showStartScreen && (
                <>
                  {/* // <div
                //   className={`brand-logo ${
                //     showEndScreen ? "brand-logo-end" : ""
                //   }`}
                //   onClick={() => {
                //     window.location.href = "https://ev.tatamotors.com";
                //   }}
                // >
                //   <img
                //     src={
                //       mediaData[
                //         `${
                //           showEndScreen || !isMobile
                //             ? "brandLogoGrey"
                //             : "brandLogo"
                //         }`
                //       ]
                //     }
                //     alt=""
                //   />
              // </div> */}
                </>
              )}

              {/* top menu */}
              {!showStartScreen &&
                !showEndScreen &&
                !showFeedbackScreen &&
                !showAllStoriesScreen &&
                isMobile && (
                  <TopThumbs
                    storyChangeHandler={storyChangeHandler}
                    currStoryId={currStoryId}
                    categoryListData={categoryListData}
                    totalNumStories={totalNumStories}
                    showAllStoriesScreen={showAllStoriesScreen}
                    setShowAllStoriesScreen={setShowAllStoriesScreen}
                    pauseSlideOnTap={pauseSlideOnTap}
                    callGaHandler={callGaHandler}
                  />
                )}
              {/* top menu */}

              {/* start screen */}
              <AnimatePresence>
                {showStartScreen && isMobile && (
                  <SplashStartWrapper
                    showStartScreen={showStartScreen}
                    splashListData={splashListData}
                    setShowStartScreen={setShowStartScreen}
                    storyChangeHandler={storyChangeHandler}
                    callGaHandler={callGaHandler}
                    currStoryId={currStoryId}
                  />
                )}
              </AnimatePresence>
              {/* start screen */}

              {/* Feedback Wrapper */}
              <AnimatePresence>
                {showFeedbackScreen && idea !== 2 && (
                  <FeedbackWrapper
                    setShowFeedbackScreen={setShowFeedbackScreen}
                    currStoryId={currStoryId}
                    callGaHandler={callGaHandler}
                    setShowEndScreen={setShowEndScreen}
                    isMobile={isMobile}
                    idea={idea}
                  />
                )}
              </AnimatePresence>
              {/* Feedback Wrapper */}

              {/* All Stories Wrapper */}
              <AnimatePresence>
                {showAllStoriesScreen && isMobile && (
                  <AllStoriesWrapper
                    setShowAllStoriesScreen={setShowAllStoriesScreen}
                    currStoryId={currStoryId}
                    callGaHandler={callGaHandler}
                    categoryListData={categoryListData}
                    storyChangeHandler={storyChangeHandler}
                    pauseSlideOnTap={pauseSlideOnTap}
                  />
                )}
              </AnimatePresence>
              {/* All Stories Wrapper */}

              {/* story swiper */}
              <AnimatePresence>
                {isDisplaySwiper()
                  ? categoryListData.map((item, index) =>
                      item.category_id === currStoryId &&
                      item.category_id !== totalNumStories ? (
                        <SwiperWrapper
                          key={item.category_id}
                          ref={swiperRef}
                          animationType={item?.animation_type}
                          chapterData={item?.chapters}
                          storyHeadText={item?.category_name}
                          totalNumStories={totalNumStories}
                          storyChangeHandler={storyChangeHandler}
                          currStoryId={currStoryId}
                          currentIndex={currentIndex}
                          setCurrentIndex={setCurrentIndex}
                          setTotalChapters={setTotalChapters}
                          fromFirstSlide={fromFirstSlide}
                          setFromFirstSlide={setFromFirstSlide}
                          fromEndScreen={fromEndScreen}
                          setFromEndScreen={setFromEndScreen}
                          setShowEndScreen={setShowEndScreen}
                          isMobile={isMobile}
                          setStoryHead={setStoryHead}
                          setChapterHashTags={setChapterHashTags}
                          chapterHashTags={chapterHashTags}
                          storyHead={storyHead}
                          callGaHandler={callGaHandler}
                          isLandscape={isLandscape}
                          categoryListData={categoryListData}
                          qrUrl={qrUrl}
                          showFeedbackScreen={showFeedbackScreen}
                          onShowFeedback={onShowFeedback}
                          showAllStoriesScreen={showAllStoriesScreen}
                          onShowAllStories={onShowAllStories}
                        />
                      ) : null
                    )
                  : null}
              </AnimatePresence>
              {/* story swiper */}

              {/* slide footer */}
              {isDisplaySwiper(true) && !showAllStoriesScreen ? (
                <div className="slide-footer">
                  <div className="footer-left">
                    <div className="slide-main-title">{storyHead}</div>
                    <div className="slide-hashtags">
                      {chapterHashTags && chapterHashTags.length > 0 ? (
                        chapterHashTags.map((item, index) => (
                          <span key={index}>{item}</span>
                        ))
                      ) : (
                        <span></span>
                      )}
                    </div>
                  </div>
                  <div
                    className="slide-footer-image"
                    onClick={() => {
                      handleNavigateTo3d();
                      callGaHandler("Explore_you_car_in_3D", "Story_screen");
                    }}
                  >
                    <img src={`${mediaData["footSwipeDummy"]}`} alt="" />
                  </div>
                </div>
              ) : null}
              {/* slide footer */}

              {/* end screens */}
              {/* end slide footer */}
              <AnimatePresence>
                {showEndScreen && (
                  <SplashEndWrapper
                    showEndScreen={showEndScreen}
                    splashListData={splashListData}
                    setShowEndScreen={setShowEndScreen}
                    currentIndex={currentIndex}
                    currStoryId={currStoryId}
                    storyChangeHandler={storyChangeHandler}
                    exploreIn3dHandler={exploreIn3dHandler}
                    callGaHandler={callGaHandler}
                    isMobile={isMobile}
                  />
                )}
              </AnimatePresence>
              {/* end slide footer */}
            </div>
            {/* rotate screen */}
            {isMobile && isLandscape ? (
              <div className="one3d-rotate-wrapper">
                <div className="one3d-rotate-inner">
                  <div className="one3d-rotate-row">
                    Rotate your phone to portrait
                  </div>
                  <div className="one3d-rotate-row">
                    <span>
                      <img src={`${mediaData["rotateIcon"]}`} alt="img" />
                    </span>
                  </div>
                  <div className="one3d-rotate-row">
                    to unlock the experience!
                  </div>
                </div>
              </div>
            ) : null}
            {/* rotate screen */}
            {!isMobile ? (
              <div className="one3d-qr-code-bottom">
                <div className="one3d-qr-code-bottom-right">
                  <QRCode
                    size={50}
                    bgColor="#E0E6F2"
                    fgColor="#313C5A"
                    style={{
                      height: "100%",
                      maxWidth: "100%",
                      width: "100%",
                    }}
                    value={qrUrl}
                    viewBox={`0 0 256 256`}
                    onClick={
                      isDisplayQRBlock
                        ? onCloseQRWrapperHandler
                        : onOpenQRWrapperHandler
                    }
                  />
                </div>
                <Modal
                  className="qr-code-modal-wrapper"
                  show={isDisplayQRBlock}
                  onHide={onCloseQRWrapperHandler}
                >
                  <QRWrapper
                    qrUrl={qrUrl}
                    isClose
                    onClose={onCloseQRWrapperHandler}
                  />
                </Modal>
              </div>
            ) : null}
          </div>
          <div className="col-12 col-xl-3 d-none pt-xl-5 d-xl-block side-panel-col">
            <div className="side-panel-main-wrapper">
              {/* button row */}
              <div className="side-panel-main-wrapper-top">
                <div className="all-stories-head">ALL STORIES</div>
                <SideStoriesWrapper
                  storyChangeHandler={storyChangeHandler}
                  currStoryId={currStoryId}
                  categoryListData={categoryListData}
                  totalNumStories={totalNumStories}
                />
              </div>

              {/* button row */}
              <div className="side-panel-main-wrapper-bottom">
                <div className="side-panel-explore mb-4 side-panel-explore-new">
                  <EndSwitchButton
                    exploreIn3dHandler={exploreIn3dHandler}
                    callGaHandler={callGaHandler}
                    isLastScreen={showEndScreen}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
